export const NAMESPACE =  'tds'
export const CSS_NS = `${NAMESPACE}-`
